module.exports = __webpack_public_path__ + "performance-good.635ec204a09dd1697858bd757b424430.hashedasset.png";